module.exports = __webpack_public_path__ + "static/media/Agri-Transporter Infographic mobile 22-02-2024 C.3a637d07.gif";